
import { ChangeDetectionStrategy, Component, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { FormDescriptionPanelComponent } from './form-description-panel';
import { FormDescriptionToggleComponent, FormInputDescriptionAlignment } from './form-description-toggle';

@Component({
  standalone: true,
  selector: 'ui-form-input-description',
  templateUrl: './form-input-description.component.html',
  styleUrl: './form-input-description.component.scss',
  imports: [
    FormDescriptionPanelComponent,
    FormDescriptionToggleComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormInputDescriptionComponent {
  public alignment: InputSignal<FormInputDescriptionAlignment> = input<FormInputDescriptionAlignment>('field');
  public description: InputSignal<string> = input.required();

  public isDescriptionVisible: WritableSignal<boolean> = signal(false);

  public toggleDescription(): void {
    this.isDescriptionVisible.update((visible) => !visible);
  }
}
